<template>
  <div id="app">
    <!-- <el-container> -->
    <!-- 后台管理-帮助中心-使用教程的paths为0，不显示头部 -->
    <!-- <el-header height="60px" v-if="!isLogin">
        <page-header @Fun_isShow_page="Fun_isShow_page" :paths="paths"></page-header>
      </el-header> -->
    <el-container style="height: 100%;" v-if="!nopermission">
      <el-aside v-show="!isLogin" class="aside scrollbarbox" style="width: 200px;z-index: 30;">
        <left-select :paths="paths"></left-select>
      </el-aside>
      <el-main style="background-color: #F1F3FF;">
        <!-- 右边顶部 -->
        <el-header height="60px" v-if="!isLogin">
          <page-header @Fun_isShow_page="Fun_isShow_page" :paths="paths"></page-header>
        </el-header>
        <!-- Note:需要隐藏面包屑的情况下 -->
        <!-- <template v-if="!isShowBreadpath">
            <breadpath class="position_relative" v-show="paths.length > 1" :paths="paths.map((i) => i.tittle)"> </breadpath>
          </template> -->

        <userInfoPage v-if="isShowout_page" @show_page="Fun_isShow_page" @out_page="Fun_isShowout_page" class="userInfo_css"></userInfoPage>
        <template v-else>
          <router-view v-show="init" class="position_relative" :key="$route.path"></router-view>
        </template>
      </el-main>
    </el-container>
    <div v-else class="have-no-permission">无权限访问</div>
    <!-- </el-container> -->
  </div>
</template>

<script>
import { loginController } from "@/api/activityController";
import { getSellerInfo } from "@/api/sellerController";
import "./utils/test";
import axios from "axios";
// import $ from "jquery";
// import { queryMenu } from "@/api/public";
import Vue from "vue";
import { mapMutations } from "vuex";
import { checkSellerOwnRorNot } from "@/api/public";
import pageHeader from "@/components/page-header"; //总的头部
import leftSelect from "@/components/left-select"; //总的侧边栏
import breadpath from "@/components/bread-path"; //总的面包屑
import userInfoPage from "@/components/user-inform";
import Document from "min-document/document";
import { authCheck } from "@/api/activityController";

export default {
  components: {
    pageHeader,
    leftSelect,
    breadpath,
    userInfoPage,
  },
  data() {
    return {
      init: false,
      isShowTip: false,
      paths: [],
      isLogin: false,
      routeVersion1: [],
      routeVersion2: [],
      routeObj: null,
      venderId: null,
      isShowBreadpath: false, //是否隐藏面包屑
      isShowout_page: false,
      userInfo: {
        //获取账号设置的信息
        contactName: "", // 联系人名称
        expiredIn: "",
        invalidateDate: "",
        isOrder: "", // 是否订购悦互动
        mobile: "", //  手机号
        picPath: "", //  店铺图片
        qq: "",
        sellerNick: "",
        sellerPin: "", //  商家Pin
        venderId: "",
        venderType: "",
      },
      isShowoutBtn: true,
      nopermission: false, // 判断权限
    };
  },
  computed: {
    headItem() {
      return this.$store.state.route; //存放在router里边的路径
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    shopTitle() {
      // 店铺名称
      return this.$store.getters.loginUserInfo.shopTitle;
    },
  },
  watch: {
    headItem: {
      deep: true,
      immediate: true,
      handler: function(nval, oval) {
        if (this.routeObj && nval && nval.length > 0) {
          //watch中需要具体执行的方法
          if (this.routeObj.path === "/login") {
            this.isLogin = true;
            return;
          }
          this.isLogin = false;
          var path = location.pathname.replace("/yusms", "");

          let route = path.split("/"), //路径里边有/,所以要截取掉
            name = [];
          let index1 = this.headItem.map((i) => i.path).indexOf("/" + route[1]); //取出所对应的索引
          index1 !== -1 &&
            name.push({
              tittle: this.headItem[index1].tittle,
              index: index1,
              path: this.headItem[index1].path,
            });
          if (this.headItem[index1] && this.headItem[index1].children && this.headItem[index1].children.length > 0) {
            // debugger
            //第一层数据的判断
            let index2 = this.headItem[index1].children.map((i) => i.path).indexOf(route[2]); //取出第二层索引
            index2 !== -1 &&
              name.push({
                tittle: this.headItem[index1].children[index2].tittle,
                index: index2,
                path: this.headItem[index1].children[index2].path,
              });
            if (
              this.headItem[index1].children[index2] &&
              this.headItem[index1].children[index2].children &&
              this.headItem[index1].children[index2].children.length > 0
            ) {
              //子层数据判断
              let index3 = this.headItem[index1].children[index2].children.map((i) => i.path).indexOf(route[3]);
              index3 !== -1 &&
                name.push({
                  tittle: this.headItem[index1].children[index2].children[index3].tittle,
                  index: index3,
                  path: this.headItem[index1].children[index2].children[index3].path,
                });
            }
          }
          this.paths = name;
          this.$store.state.pathNow = name;
        }
      },
    },
    $route: {
      //监听路由信息对象
      deep: true, //监听的数据深度,一般用来监听对象中某个属性的变化
      immediate: true, //在选项参数中指定true将立即以表达式的当前值触发回调
      handler: async function(newval, oldval) {
        // 无权限判断
        if(newval.query.permission == "false") {
          this.nopermission = true
          return
        } else {
          this.nopermission = false
        }
        // console.log(newval, 6666);
        //需要隐藏面包屑的页面
        this.isShowBreadpath = newval.path === "/integralCenter/home" ? true : false;
        this.isShowBreadpath = newval.path === "/integralCenter/brandCustom" ? true : false;
        this.routeObj = newval;
        //watch中需要具体执行的方法
        if (newval.path === "/login" || newval.path === "/redirection") {
          this.isLogin = true;
          return;
        }

        // 跳转详情页  菜单样式不变
        if (newval.path.indexOf("throw") > -1) return;
        this.isLogin = false;
        var path = location.pathname.replace("/yusms", "");

        let route = path.split("/"), //路径里边有/,所以要截取掉
          name = [];
        let index1 = this.headItem.map((i) => i.path).indexOf("/" + route[1]); //取出所对应的索引
        index1 !== -1 &&
          name.push({
            tittle: this.headItem[index1].tittle,
            index: index1,
            path: this.headItem[index1].path,
          });
        if (this.headItem[index1] && this.headItem[index1].children && this.headItem[index1].children.length > 0) {
          // debugger
          //第一层数据的判断
          let index2 = this.headItem[index1].children.map((i) => i.path).indexOf(route[2]); //取出第二层索引
          index2 !== -1 &&
            name.push({
              tittle: this.headItem[index1].children[index2].tittle,
              index: index2,
              path: this.headItem[index1].children[index2].path,
            });
          if (
            this.headItem[index1].children[index2] &&
            this.headItem[index1].children[index2].children &&
            this.headItem[index1].children[index2].children.length > 0
          ) {
            //子层数据判断
            let index3 = this.headItem[index1].children[index2].children.map((i) => i.path).indexOf(route[3]);
            index3 !== -1 &&
              name.push({
                tittle: this.headItem[index1].children[index2].children[index3].tittle,
                index: index3,
                path: this.headItem[index1].children[index2].children[index3].path,
              });
          }
        }
        this.paths = name;
        this.$store.state.pathNow = name;
      },
    },
    // shopTitle: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal, oldVal) {
    // console.log('this.shopTitle', this.shopTitle)
    // if (this.shopTitle == '服务市场测试店铺' || this.shopTitle == '初缘旗舰店' || this.shopTitle == '361度逸航专卖店') {
    //   this.$store.state.route = this.routeVersion1;
    // }else {
    //   this.$store.state.route = this.routeVersion2;
    // }
    //   }
    // }
  },
  created() {
    sessionStorage.setItem("isPopVisiv", "true");
    // window.reload()
    // window.onload = () => {
    //   window.reload();
    // }
  },
  mounted() {
    sessionStorage.setItem("TimeRenew", true), //Note:店铺软件系统到期的标识状态 21/9/17
      (Vue.prototype.$checkSellerOwnRorNot = checkSellerOwnRorNot);
    if (location.pathname != "/login" && location.pathname != "/redirection") {
      getSellerInfo().then((res) => {
        if (res.code == 1) {
          this.init = true
        }
      })
    } else {
      this.init = true
    }
    this.$store.state.topPx = document.getElementsByClassName("el-header")[0].clientHeight;
  },
  methods: {
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
    }),

    Fun_isShowout_page() {
      this.isShowout_page = false;
    },
    Fun_isShow_page() {
      this.isShowout_page = true;
    },
  },
};
</script>

<style lang="scss">
.qrcode {
  img {
    width: 300px;
    height: 300px;
  }
}
.have-no-permission {
  color: #666;
  font-size: 14px;
  padding: 20px;
}
.scrollbarbox {
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #bfbfbf;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #f3f3f3;
  }
}
/deep/ .swiper-pagination-bullet-active {
  background-color: #7b61ff !important;
  width: 8px;
  height: 8px;
}

.el-popover {
  padding: 12px !important;
}

body {
  margin: 0;
  font-size: 14px;
}

/deep/ .el-cascader__dropdown {
  z-index: 3333 !important;
}

.el-date-picker__time-header .el-date-picker__editor-wrap .el-time-panel {
  left: -48px !important;
}

#app {
  font-family: "Microsoft YaHei", "Arial", "Helvetica", "sans-serif", "font_family" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: #f5f8fa;
  font-size: 14px;
  margin-left: 0px;
}

#app .el-header {
  padding: 0;
}

#app .aside {
  padding: 0;
  width: 200px !important;
  background: #121432;
  border-radius: 0px 24px 0px 0px;
}

#app .el-main {
  padding: 0;
  margin: 0;
  position: relative;
}

#app /deep/.v-modal {
  z-index: 2888 !important;
}

.position_relative {
  position: relative;
}

.userInfo_css {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9;
  background: red;
  top: 0;
}

::v-deep {
  .el-dialog__wrapper {
    z-index: 3062;
  }
}

.sys-dialog {
  z-index: 5000 !important;
}

.sys-title {
  text-align: center;
  font-weight: 700;
  font-size: 16px;
}

.sys-com {
  font-weight: 600;
  font-size: 14px;
  margin: 20px 0 30px 0;
  line-height: 18px;
}

.sys-btn {
  display: flex;
  justify-content: center;
}
</style>
